import { useEffect, useState } from 'react';
import CategorySelect from '../../components/categorySelect/categorySelect';
import ExternalLink from '../../components/externalLink/externalLink';
import styles from './servicesStep.module.css';

export default function ServicesStep ({ formData, setFormData }) {
  const [content, setContent] = useState({
    title: '',
    blurb: ''
  });

  useEffect(() => {
    if (formData.providerStep.provider === 'registered') {
      setContent({
        title: 'What service/s do you deliver?',
        blurb:
          'Understanding the service types you deliver allows us to show the relevant requirements.'
      });
    } else if (formData.providerStep.provider === 'prospective') {
      setContent({
        title: 'What service/s do you intend to deliver?',
        blurb:
          'Understanding the service types you are interested in allows us to show the relevant requirements.'
      });
    } else {
      setContent({
        title:
          'What provider requirements are you interested in finding out more about?',
        blurb:
          'Understanding the requirements related to Registration Categories and Service Types allows us to tailor the results'
      });
    }
  }, []);

  return (
    <div className={styles.stepContainer}>
      <h2 className={styles.stepTitle}>{content.title}</h2>
      <div className={styles.blurbContainer}>
        <p className={styles.blurbText}>{content.blurb}</p>
        {formData.providerStep.provider === 'prospective' || formData.providerStep.provider === 'registered'
          ? (
            <ExternalLink href='https://www.legislation.gov.au/F2025L01173/latest/text'>
              I'm not sure
            </ExternalLink>
            )
          : (
            <p className={styles.selectText}>Select all that apply</p>
            )}
      </div>

      <CategorySelect
        categories={formData.servicesStep.serviceCategories}
        setFormData={setFormData}
      />
    </div>
  );
}
